import { useEffect, useState } from 'react';
import type { CampaignConfig } from '../types';
import { Modal } from './Modal';

export function DispoScreen({ config, selected, onSelect, onSubmit, pauseAfter, onPauseAfter }: {
  config: CampaignConfig; selected: string | null; onSelect: (code: string) => void;
  onSubmit: (code: string, comments: string) => void; pauseAfter: boolean; onPauseAfter: (v: boolean) => void;
}) {
  const [comments, setComments] = useState('');
  const statuses = config.statuses.filter((s) => s.selectable);
  const rows = Math.max(1, config.rows_per_column || 4);
  const hotkey = (code: string) => config.hotkeys.find((h) => h.code === code)?.key;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.target as HTMLElement)?.tagName === 'TEXTAREA' || (e.target as HTMLElement)?.tagName === 'INPUT') return;
      const hk = config.hotkeys.find((h) => h.key === e.key);
      if (hk) { e.preventDefault(); onSubmit(hk.code, comments); }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [config, comments, onSubmit]);
  return (
    <Modal id="DispoSelectBox" title="Disposition">
      <div className="grid" style={{ gridTemplateRows: `repeat(${rows}, auto)` }}>
        {statuses.map((s) => (
          <button key={s.code} className={selected === s.code ? 'selected' : ''} onClick={() => onSelect(s.code)}>
            {hotkey(s.code) && <span className="hotkey">{hotkey(s.code)}</span>}{s.name} <span style={{ color: 'var(--muted)' }}>({s.code})</span>
          </button>
        ))}
      </div>
      <div style={{ marginTop: 12 }}>
        <label>Call notes</label>
        <textarea id="call_notes_dispo" rows={2} value={comments} onChange={(e) => setComments(e.target.value)} />
      </div>
      <label className="check" style={{ marginTop: 8 }}><input type="checkbox" checked={pauseAfter} onChange={(e) => onPauseAfter(e.target.checked)} /> Pause dialing after this call</label>
      <div className="actions">
        <button onClick={() => onSelect('')}>Clear</button>
        <button className="primary" disabled={!selected} onClick={() => selected && onSubmit(selected, comments)}>Submit</button>
      </div>
    </Modal>
  );
}
